type WithSubcategories<S> = {
  subcategories?: S[] | null;
};

/**
 * Picks the subcategory to show after the active category (or its subcategory list) changes.
 * Reuses the previous selection when the same label still exists; otherwise defaults to the first subcategory.
 */
export function resolveSubcategoryForCategory<
  S extends { subcategoryLabel: string },
>(
  prevSubcategory: S | undefined,
  category: WithSubcategories<S> | undefined,
): S | undefined {
  const subs = category?.subcategories;
  if (!subs?.length) return undefined;
  if (!prevSubcategory) return subs[0];
  const stillThere = subs.find(
    (s) => s.subcategoryLabel === prevSubcategory.subcategoryLabel,
  );
  return stillThere ?? subs[0];
}
